import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ion-align-items-center ion-justify-content-start",
  style: {"display":"flex"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Meine Challenges", -1)

import {ref, watch} from "vue";
import {isPlatform} from '@ionic/vue';
import {IonIcon} from '@ionic/vue';
import * as icons from 'ionicons/icons';
import useChallenge from "@/composable/useChallenge";
import {Challenge} from "@/mobipoints/challenge/challenge/challenge.type";
import ChallengeTeaser from "@/components/challenge/ChallengeTeaser.vue";
import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import { Swiper, SwiperSlide } from 'swiper/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveChallengeList',
  setup(__props) {

const challengeFacade = useChallenge();

const activeChallengeList = ref<Challenge[]>(challengeFacade.activeChallenges.value);

watch(challengeFacade.activeChallenges, async () => {
  activeChallengeList.value = challengeFacade.activeChallenges.value;
});

return (_ctx: any,_cache: any) => {
  return (activeChallengeList.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        class: "ion-padding",
        key: activeChallengeList.value.length
      }, [
        _createElementVNode("h3", _hoisted_1, [
          _createVNode(_unref(IonIcon), {
            icon: icons.star,
            style: {"margin-right":".25em"}
          }, null, 8, ["icon"]),
          _hoisted_2
        ]),
        (_unref(isPlatform)('ios') || _unref(isPlatform)('android'))
          ? (_openBlock(), _createBlock(_unref(Swiper), {
              key: 0,
              height: 200,
              "slides-per-view": 1.3,
              loop: false,
              "space-between": 0
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeChallengeList.value, (challenge) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                    key: challenge.uuid
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ChallengeTeaser, {
                        uuid: challenge.uuid,
                        "show-progress": "full"
                      }, null, 8, ["uuid"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(Swiper), {
              key: 1,
              height: 200,
              "slides-per-view": 2.3,
              loop: false,
              "space-between": 0
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeChallengeList.value, (challenge) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                    key: challenge.uuid
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ChallengeTeaser, {
                        uuid: challenge.uuid,
                        "show-progress": "full"
                      }, null, 8, ["uuid"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}
}

})